

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { appsApi } from '@/features/apps/shared/services/apps';
import { CreatePrivateAppViewModel } from '@/features/apps/shared/models';

import Toast from '@/shared/services/toast';

import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';

@Component({
	mixins: [validationMixin],
	validations: {
		appName: { required }
	}
})
export default class CreatePrivateApp extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Action(HANDLE_SERIOUS_ERROR) public handleSeriousError: any;

	public appName: string = '';
	public actionInProgress: boolean = false;

	public created() {
		if (!this.currentWorkspace) {
			this.handleSeriousError('No workspace selected');
			return;
		}
	}

	public save() {
		if (this.actionInProgress) {
			return;
		}

		this.actionInProgress = true;

		const request = {
			appName: this.appName,
		} as CreatePrivateAppViewModel;

		appsApi.createPrivateApp(this.currentWorkspace.id, request)
			.then((result) => {
				this.$router.push({ name: 'private-apps-edit', params: { id: result.app.id} });
			})
			.catch((err) => Toast.showError(err.message))
			.finally(() => this.actionInProgress = false);
	}

	public cancel() {
		this.$router.push({ name: 'private-apps-list' });
	}
}
